import axios from "axios";

const environmentType = 'formal'; // 正式
// const environmentType = 'test'; // 测试
// const environmentType = 'dev'; // 开发

var apiUrl, webLink;
if (environmentType === 'formal') {
    apiUrl = 'https://h5.qianzhuvisa.com/prod-api';
    webLink = 'https://h5.qianzhuvisa.com';
}

if (environmentType === 'test') {
    apiUrl = 'https://h5.qianzhu.51emin.com/prod-api';
    webLink = 'https://h5.qianzhu.51emin.com';
}

if (environmentType === 'dev') {
    apiUrl = 'http://localhost:8006';
    webLink = 'http://localhost:8086';
}

var setPvUv = (fu) => {
    if (environmentType === 'formal') {
        fu && fu();
    }
}

// 邮箱验证
var emailReg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;

// 手机号验证
var phoneReg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;

// 时间缓存
var foowwLocalStorage = {
    set: function set(key, value, ttl_ms) {
        var data = {
            value: value,
            expirse: new Date(ttl_ms).getTime()
        };
        localStorage.setItem(key, JSON.stringify(data));
    },
    get: function get(key) {
        var data = JSON.parse(localStorage.getItem(key));
        if (data !== null) {
            if (data.expirse != null && data.expirse < new Date().getTime()) {
                localStorage.removeItem(key);
            } else {
                return data.value;
            }
        }
        return null;
    }
};

var toastTimer;

function showToast(msg, duration, top) {
    clearTimeout(toastTimer);
    var ToastBox = document.getElementsByClassName('toastDiv-box')[0];
    if (ToastBox) document.body.removeChild(ToastBox); //防止重复弹出
    duration = isNaN(duration) ? 3000 : duration;
    var m = document.createElement('div');
    m.className = 'toastDiv-box';
    m.innerHTML = msg;
    top = top ? top : '40%';
    m.style.cssText = `width: 60%;min-width: 150px;opacity: 0.7;height: auto;color: rgb(255, 255, 255);text-align: center;padding: 10px;border-radius: 5px;position: fixed;top: ${top};left: 50%;transform: translateX(-50%);z-index: 9999999999999;background: rgb(0, 0, 0);font-size: 14px;overflow: hidden;`;
    document.body.appendChild(m);
    toastTimer = setTimeout(function () {
        var d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m);
        }, d * 1000);
    }, duration);
}

var continent = [
    {
    label: '亚洲',
    value: 1
},

{
    label: '北美洲',
    value: 2
},

{
    label: '南美洲',
    value: 3
},

{
    label: '大洋洲',
    value: 4
},

{
    label: '欧洲',
    value: 5
},

{
    label: '非洲',
    value: 6
},

{
    label: '南极洲',
    value: 7
},
]

var provinceList = [
    {
    value: "11",
    label: "北京"
},
{
    value: "44",
    label: "广东"
},
{
    value: "31",
    label: "上海"
},
{
    value: "33",
    label: "浙江"
},
{
    value: "12",
    label: "天津"
},
{
    value: "32",
    label: "江苏"
},
{
    value: "51",
    label: "四川"
},
{
    value: "35",
    label: "福建"
},
{
    value: "13",
    label: "河北"
},
{
    value: "21",
    label: "辽宁"
},
{
    value: "42",
    label: "湖北"
},
{
    value: "50",
    label: "重庆"
},
{
    value: "15",
    label: "内蒙古"
},
{
    value: "22",
    label: "吉林"
},
{
    value: "23",
    label: "黑龙江"
},
{
    value: "14",
    label: "山西"
},
{
    value: "34",
    label: "安徽"
},
{
    value: "36",
    label: "江西"
},
{
    value: "37",
    label: "山东"
},
{
    value: "41",
    label: "河南"
},
{
    value: "43",
    label: "湖南"
},
{
    value: "45",
    label: "广西"
},
{
    value: "46",
    label: "海南"
},
{
    value: "52",
    label: "贵州"
},
{
    value: "53",
    label: "云南"
},
{
    value: "61",
    label: "陕西"
},
{
    value: "62",
    label: "甘肃"
},
{
    value: "63",
    label: "青海"
},
{
    value: "64",
    label: "宁夏"
},
{
    value: "54",
    label: "西藏"
},
{
    value: "65",
    label: "新疆"
},
{
    value: "81",
    label: "香港"
},
]

var scrollTop = 0;

var bodyNoSliding = function () {
    scrollTop = $(window).scrollTop();;
    $('body').css({
        'overflow-y': 'hidden',
        position: 'fixed',
        top: -scrollTop
    }).addClass('unscrollbar')
}

var bodySliding = function () {
    $('body').css({
        'overflow-y': 'visible',
        position: 'relative',
        top: 0
    }).removeClass('unscrollbar')
    window.scrollTo(0, scrollTop)
    $('.weui-mask').parent().css({
        opacity: 0,
        display: 'none'
    })
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

const formatTime = (date, e) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    if (e == 1) {
        return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
    } else if (e == 2) {
        return [year, month, day].map(formatNumber).join('.');
    } else if (e == 3) {
        return [year, month, day].map(formatNumber).join('-');
    }
}

//计算周岁年龄的函数
function getAge(birthday) {
    //定义返回值
    var returnAge;

    var birthDayTime = new Date(birthday.replace(/-/g, "/"));
    //获取输入框参数
    var birthYear = birthDayTime.getFullYear();
    var birthMonth = birthDayTime.getMonth() + 1;
    var birthDay = birthDayTime.getDate();

    //获取当前时间
    var d = new Date();
    var nowYear = d.getFullYear()
    var nowMonth = d.getMonth() + 1
    var nowDay = d.getDate()

    //计算周岁年龄差
    if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay //日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1
                } else {
                    returnAge = ageDiff
                }
            } else {
                var monthDiff = nowMonth - birthMonth //月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1
                } else {
                    returnAge = ageDiff
                }
            }
        } else {
            returnAge = -1 //输入有误
        }
    }
    return returnAge;
}


var identityType = [
    {
    name: '在职人员',
    desc: '企业、事业单位员工',
    show: false,
    check: false,
    value: '1'
},
{
    name: '自由职业者',
    desc: '自由职业、个体经营者',
    show: false,
    check: false,
    value: '2'
},
{
    name: '退休人员',
    desc: '退休、离休人员',
    show: false,
    check: false,
    value: '3'
},
{
    name: '18岁以上在校学生',
    desc: '18岁以上学生',
    show: false,
    check: false,
    value: '4'
},
{
    name: '18岁以下在校学生',
    desc: '18岁以下学生、学龄前儿童',
    show: false,
    check: false,
    value: '5'
},
{
    name: '无业人员',
    desc: '全职太太、待业等',
    show: false,
    check: false,
    value: '6'
},
];

var relationList = [
    {
    name: '主申请人',
    value: '1'
},
{
    name: '申请人配偶',
    value: '2'
},
{
    name: '申请人子女',
    value: '3'
},
{
    name: '其他',
    value: '4'
},
];


var visaTypeList = [
    {
    label: '旅游签',
    value: '1',
},
{
    label: '商务签',
    value: '2',
},
{
    label: '探亲访友签',
    value: '3',
},
{
    label: '留学签',
    value: '4',
},
{
    label: '陪读签',
    value: '5',
},
{
    label: '视客户情况而定',
    value: '6',
},
];


// 获取问号后面的参数
function getRequest() {
    var arr = location.href.split('?');

    var newArr = [];
    arr.forEach(ele => {
        newArr.push('?' + ele);
    })

    var theRequest = new Object();
    newArr.forEach(ele => {
        if (ele.indexOf("?") != -1) {
            var str = ele.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
    })

    return theRequest;
};

// 字符串转码
function urlencode(str) {
    str = (str + '').toString();
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
        replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

// 授权
function authorize(that, type, fun) {
    var query = getRequest();

    if (type == 1) {
        var redirect_uri = urlencode(location.href);
        var appid = 'wxe94fa1f0f3090303';
        var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`;
        if (location.href.indexOf('localhost:80') == -1) {
            location.href = url;
        }
    }

    if (type == 2) {
        if (query.code) {
            var request = {};
            request.code = query.code;
            that.axios.post(apiUrl + '/h5/refreshOpenid', request).then(function (res) {
                fun && fun();
            })
        }
    }
};



// 订单详情授权
function authorizeOrder(that) {
    var query = getRequest();

    if (query.code) {
        var request = {};
        request.code = query.code;
        request.orderCode = query.orderCode;
        that.axios.post(apiUrl + '/h5/checkLogin', request).then(function (res) {
            var endTime = new Date().getTime() + 3600000 * 24 * 7;
            that.comm.foowwLocalStorage.set('token', res.token, endTime);
            that.getData();
        })
    } else {
        var redirect_uri = urlencode(location.href);
        var appid = 'wxe94fa1f0f3090303';
        var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`;
        if (location.href.indexOf('localhost:80') == -1) {
            location.href = url;
        }
    }
};

var yearList = [
    {
    "label": "1900年",
    "value": 1900,
    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1901年",
    "value": 1901,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1902年",
    "value": 1902,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1903年",
    "value": 1903,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1904年",
    "value": 1904,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1905年",
    "value": 1905,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1906年",
    "value": 1906,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1907年",
    "value": 1907,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1908年",
    "value": 1908,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1909年",
    "value": 1909,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1910年",
    "value": 1910,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1911年",
    "value": 1911,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1912年",
    "value": 1912,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1913年",
    "value": 1913,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1914年",
    "value": 1914,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1915年",
    "value": 1915,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1916年",
    "value": 1916,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1917年",
    "value": 1917,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1918年",
    "value": 1918,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1919年",
    "value": 1919,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1920年",
    "value": 1920,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1921年",
    "value": 1921,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1922年",
    "value": 1922,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1923年",
    "value": 1923,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1924年",
    "value": 1924,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1925年",
    "value": 1925,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1926年",
    "value": 1926,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1927年",
    "value": 1927,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1928年",
    "value": 1928,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1929年",
    "value": 1929,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1930年",
    "value": 1930,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1931年",
    "value": 1931,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1932年",
    "value": 1932,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1933年",
    "value": 1933,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1934年",
    "value": 1934,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1935年",
    "value": 1935,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1936年",
    "value": 1936,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1937年",
    "value": 1937,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1938年",
    "value": 1938,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1939年",
    "value": 1939,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1940年",
    "value": 1940,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1941年",
    "value": 1941,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1942年",
    "value": 1942,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1943年",
    "value": 1943,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1944年",
    "value": 1944,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1945年",
    "value": 1945,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1946年",
    "value": 1946,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1947年",
    "value": 1947,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1948年",
    "value": 1948,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1949年",
    "value": 1949,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1950年",
    "value": 1950,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1951年",
    "value": 1951,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1952年",
    "value": 1952,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1953年",
    "value": 1953,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1954年",
    "value": 1954,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1955年",
    "value": 1955,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1956年",
    "value": 1956,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1957年",
    "value": 1957,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1958年",
    "value": 1958,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1959年",
    "value": 1959,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1960年",
    "value": 1960,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1961年",
    "value": 1961,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1962年",
    "value": 1962,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1963年",
    "value": 1963,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1964年",
    "value": 1964,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1965年",
    "value": 1965,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1966年",
    "value": 1966,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1967年",
    "value": 1967,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1968年",
    "value": 1968,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1969年",
    "value": 1969,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1970年",
    "value": 1970,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1971年",
    "value": 1971,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1972年",
    "value": 1972,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1973年",
    "value": 1973,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1974年",
    "value": 1974,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1975年",
    "value": 1975,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1976年",
    "value": 1976,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1977年",
    "value": 1977,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1978年",
    "value": 1978,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1979年",
    "value": 1979,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1980年",
    "value": 1980,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1981年",
    "value": 1981,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1982年",
    "value": 1982,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1983年",
    "value": 1983,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1984年",
    "value": 1984,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1985年",
    "value": 1985,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1986年",
    "value": 1986,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1987年",
    "value": 1987,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1988年",
    "value": 1988,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1989年",
    "value": 1989,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1990年",
    "value": 1990,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1991年",
    "value": 1991,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1992年",
    "value": 1992,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1993年",
    "value": 1993,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1994年",
    "value": 1994,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1995年",
    "value": 1995,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1996年",
    "value": 1996,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1997年",
    "value": 1997,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1998年",
    "value": 1998,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "1999年",
    "value": 1999,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2000年",
    "value": 2000,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2001年",
    "value": 2001,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2002年",
    "value": 2002,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2003年",
    "value": 2003,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2004年",
    "value": 2004,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2005年",
    "value": 2005,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2006年",
    "value": 2006,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2007年",
    "value": 2007,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2008年",
    "value": 2008,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2009年",
    "value": 2009,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2010年",
    "value": 2010,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2011年",
    "value": 2011,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2012年",
    "value": 2012,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2013年",
    "value": 2013,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2014年",
    "value": 2014,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2015年",
    "value": 2015,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2016年",
    "value": 2016,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2017年",
    "value": 2017,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2018年",
    "value": 2018,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2019年",
    "value": 2019,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2020年",
    "value": 2020,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2021年",
    "value": 2021,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2022年",
    "value": 2022,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2023年",
    "value": 2023,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2024年",
    "value": 2024,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2025年",
    "value": 2025,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2026年",
    "value": 2026,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2027年",
    "value": 2027,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2028年",
    "value": 2028,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2029年",
    "value": 2029,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2030年",
    "value": 2030,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2031年",
    "value": 2031,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2032年",
    "value": 2032,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2033年",
    "value": 2033,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2034年",
    "value": 2034,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2035年",
    "value": 2035,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2036年",
    "value": 2036,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2037年",
    "value": 2037,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2038年",
    "value": 2038,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2039年",
    "value": 2039,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2040年",
    "value": 2040,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2041年",
    "value": 2041,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2042年",
    "value": 2042,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2043年",
    "value": 2043,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2044年",
    "value": 2044,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2045年",
    "value": 2045,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2046年",
    "value": 2046,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2047年",
    "value": 2047,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2048年",
    "value": 2048,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2049年",
    "value": 2049,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2050年",
    "value": 2050,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2051年",
    "value": 2051,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2052年",
    "value": 2052,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2053年",
    "value": 2053,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2054年",
    "value": 2054,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2055年",
    "value": 2055,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2056年",
    "value": 2056,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2057年",
    "value": 2057,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2058年",
    "value": 2058,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2059年",
    "value": 2059,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2060年",
    "value": 2060,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2061年",
    "value": 2061,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2062年",
    "value": 2062,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2063年",
    "value": 2063,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2064年",
    "value": 2064,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2065年",
    "value": 2065,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2066年",
    "value": 2066,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2067年",
    "value": 2067,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2068年",
    "value": 2068,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2069年",
    "value": 2069,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2070年",
    "value": 2070,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2071年",
    "value": 2071,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2072年",
    "value": 2072,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2073年",
    "value": 2073,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2074年",
    "value": 2074,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2075年",
    "value": 2075,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2076年",
    "value": 2076,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2077年",
    "value": 2077,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2078年",
    "value": 2078,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2079年",
    "value": 2079,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2080年",
    "value": 2080,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2081年",
    "value": 2081,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2082年",
    "value": 2082,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2083年",
    "value": 2083,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2084年",
    "value": 2084,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2085年",
    "value": 2085,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2086年",
    "value": 2086,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2087年",
    "value": 2087,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2088年",
    "value": 2088,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2089年",
    "value": 2089,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2090年",
    "value": 2090,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2091年",
    "value": 2091,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2092年",
    "value": 2092,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2093年",
    "value": 2093,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2094年",
    "value": 2094,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2095年",
    "value": 2095,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2096年",
    "value": 2096,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2097年",
    "value": 2097,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2098年",
    "value": 2098,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
},
{
    "label": "2099年",
    "value": 2099,

    children: [{
        "label": "1月",
        "value": '01',
    }, {
        "label": "2月",
        "value": '02',
    }, {
        "label": "3月",
        "value": '03',
    }, {
        "label": "4月",
        "value": '04',
    }, {
        "label": "5月",
        "value": '05',
    }, {
        "label": "6月",
        "value": '06',
    }, {
        "label": "7月",
        "value": '08',
    }, {
        "label": "8月",
        "value": '08',
    }, {
        "label": "9月",
        "value": '09',
    }, {
        "label": "10月",
        "value": '10',
    }, {
        "label": "11月",
        "value": '11',
    }, {
        "label": "12月",
        "value": '12',
    },]
}
];


var provinceJson = [
    {
    "label": "北京市",
    "value": "北京市",
    "children": [{
        "label": "北京市",
        "value": "北京市"
    }]
},
{
    "label": "上海市",
    "value": "上海市",
    "children": [{
        "label": "上海市",
        "value": "上海市"
    }]
},
{
    "label": "天津市",
    "value": "天津市",
    "children": [{
        "label": "天津市",
        "value": "天津市"
    }]
},
{
    "label": "重庆市",
    "value": "重庆市",
    "children": [{
        "label": "重庆市",
        "value": "重庆市"
    }]
},
{
    "label": "广东省",
    "value": "广东省",
    "children": [{
        "label": "广州市",
        "value": "广州市"
    },
    {
        "label": "深圳市",
        "value": "深圳市"
    },
    {
        "label": "东莞市",
        "value": "东莞市"
    },
    {
        "label": "惠州市",
        "value": "惠州市"
    },
    {
        "label": "珠海市",
        "value": "珠海市"
    },
    {
        "label": "佛山市",
        "value": "佛山市"
    },
    {
        "label": "中山市",
        "value": "中山市"
    },
    {
        "label": "潮州市",
        "value": "潮州市"
    },
    {
        "label": "揭阳市",
        "value": "揭阳市"
    },
    {
        "label": "汕头市",
        "value": "汕头市"
    },
    {
        "label": "汕尾市",
        "value": "汕尾市"
    },
    {
        "label": "清远市",
        "value": "清远市"
    },
    {
        "label": "云浮市",
        "value": "云浮市"
    },
    {
        "label": "韶关市",
        "value": "韶关市"
    },
    {
        "label": "江门市",
        "value": "江门市"
    },
    {
        "label": "湛江市",
        "value": "湛江市"
    },
    {
        "label": "茂名市",
        "value": "茂名市"
    },
    {
        "label": "肇庆市",
        "value": "肇庆市"
    },
    {
        "label": "河源市",
        "value": "河源市"
    },
    {
        "label": "梅州市",
        "value": "梅州市"
    },
    {
        "label": "阳江市",
        "value": "阳江市"
    }
    ]
},
{
    "label": "江苏省",
    "value": "江苏省",
    "children": [{
        "label": "南京市",
        "value": "南京市"
    },
    {
        "label": "无锡市",
        "value": "无锡市"
    },
    {
        "label": "苏州市",
        "value": "苏州市"
    },
    {
        "label": "常州市",
        "value": "常州市"
    },
    {
        "label": "镇江市",
        "value": "镇江市"
    },
    {
        "label": "南通市",
        "value": "南通市"
    },
    {
        "label": "泰州市",
        "value": "泰州市"
    },
    {
        "label": "扬州市",
        "value": "扬州市"
    },
    {
        "label": "盐城市",
        "value": "盐城市"
    },
    {
        "label": "连云港市",
        "value": "连云港市"
    },
    {
        "label": "徐州市",
        "value": "徐州市"
    },
    {
        "label": "淮安市",
        "value": "淮安市"
    },
    {
        "label": "宿迁市",
        "value": "宿迁市"
    }
    ]
},
{
    "label": "山东省",
    "value": "山东省",
    "children": [{
        "label": "济南市",
        "value": "济南市"
    },
    {
        "label": "青岛市",
        "value": "青岛市"
    },
    {
        "label": "淄博市",
        "value": "淄博市"
    },
    {
        "label": "枣庄市",
        "value": "枣庄市"
    },
    {
        "label": "东营市",
        "value": "东营市"
    },
    {
        "label": "烟台市",
        "value": "烟台市"
    },
    {
        "label": "潍坊市",
        "value": "潍坊市"
    },
    {
        "label": "济宁市",
        "value": "济宁市"
    },
    {
        "label": "泰安市",
        "value": "泰安市"
    },
    {
        "label": "威海市",
        "value": "威海市"
    },
    {
        "label": "日照市",
        "value": "日照市"
    },
    {
        "label": "莱芜市",
        "value": "莱芜市"
    },
    {
        "label": "临沂市",
        "value": "临沂市"
    },
    {
        "label": "德州市",
        "value": "德州市"
    },
    {
        "label": "聊城市",
        "value": "聊城市"
    },
    {
        "label": "滨州市",
        "value": "滨州市"
    },
    {
        "label": "菏泽市",
        "value": "菏泽市"
    }
    ]
},
{
    "label": "浙江省",
    "value": "浙江省",
    "children": [{
        "label": "杭州市",
        "value": "杭州市"
    },
    {
        "label": "宁波市",
        "value": "宁波市"
    },
    {
        "label": "温州市",
        "value": "温州市"
    },
    {
        "label": "嘉兴市",
        "value": "嘉兴市"
    },
    {
        "label": "湖州市",
        "value": "湖州市"
    },
    {
        "label": "绍兴市",
        "value": "绍兴市"
    },
    {
        "label": "金华市",
        "value": "金华市"
    },
    {
        "label": "衢州市",
        "value": "衢州市"
    },
    {
        "label": "舟山市",
        "value": "舟山市"
    },
    {
        "label": "台州市",
        "value": "台州市"
    },
    {
        "label": "丽水市",
        "value": "丽水市"
    }
    ]
},
{
    "label": "河南省",
    "value": "河南省",
    "children": [{
        "label": "郑州市",
        "value": "郑州市"
    },
    {
        "label": "开封市",
        "value": "开封市"
    },
    {
        "label": "洛阳市",
        "value": "洛阳市"
    },
    {
        "label": "平顶山市",
        "value": "平顶山市"
    },
    {
        "label": "安阳市",
        "value": "安阳市"
    },
    {
        "label": "鹤壁市",
        "value": "鹤壁市"
    },
    {
        "label": "新乡市",
        "value": "新乡市"
    },
    {
        "label": "焦作市",
        "value": "焦作市"
    },
    {
        "label": "濮阳市",
        "value": "濮阳市"
    },
    {
        "label": "许昌市",
        "value": "许昌市"
    },
    {
        "label": "漯河市",
        "value": "漯河市"
    },
    {
        "label": "三门峡市",
        "value": "三门峡市"
    },
    {
        "label": "南阳市",
        "value": "南阳市"
    },
    {
        "label": "商丘市",
        "value": "商丘市"
    },
    {
        "label": "信阳市",
        "value": "信阳市"
    },
    {
        "label": "周口市",
        "value": "周口市"
    },
    {
        "label": "驻马店市",
        "value": "驻马店市"
    },
    {
        "label": "济源市",
        "value": "济源市"
    }
    ]
},
{
    "label": "四川省",
    "value": "四川省",
    "children": [{
        "label": "成都市",
        "value": "成都市"
    },
    {
        "label": "自贡市",
        "value": "自贡市"
    },
    {
        "label": "攀枝花市",
        "value": "攀枝花市"
    },
    {
        "label": "泸州市",
        "value": "泸州市"
    },
    {
        "label": "德阳市",
        "value": "德阳市"
    },
    {
        "label": "绵阳市",
        "value": "绵阳市"
    },
    {
        "label": "广元市",
        "value": "广元市"
    },
    {
        "label": "遂宁市",
        "value": "遂宁市"
    },
    {
        "label": "内江市",
        "value": "内江市"
    },
    {
        "label": "乐山市",
        "value": "乐山市"
    },
    {
        "label": "南充市",
        "value": "南充市"
    },
    {
        "label": "眉山市",
        "value": "眉山市"
    },
    {
        "label": "宜宾市",
        "value": "宜宾市"
    },
    {
        "label": "广安市",
        "value": "广安市"
    },
    {
        "label": "达州市",
        "value": "达州市"
    },
    {
        "label": "雅安市",
        "value": "雅安市"
    },
    {
        "label": "巴中市",
        "value": "巴中市"
    },
    {
        "label": "资阳市",
        "value": "资阳市"
    },
    {
        "label": "阿坝藏族羌族自治州",
        "value": "阿坝藏族羌族自治州"
    },
    {
        "label": "甘孜藏族自治州",
        "value": "甘孜藏族自治州"
    },
    {
        "label": "凉山彝族自治州",
        "value": "凉山彝族自治州"
    }
    ]
},
{
    "label": "湖北省",
    "value": "湖北省",
    "children": [{
        "label": "武汉市",
        "value": "武汉市"
    },
    {
        "label": "黄石市",
        "value": "黄石市"
    },
    {
        "label": "十堰市",
        "value": "十堰市"
    },
    {
        "label": "宜昌市",
        "value": "宜昌市"
    },
    {
        "label": "襄阳市",
        "value": "襄阳市"
    },
    {
        "label": "鄂州市",
        "value": "鄂州市"
    },
    {
        "label": "荆门市",
        "value": "荆门市"
    },
    {
        "label": "孝感市",
        "value": "孝感市"
    },
    {
        "label": "荆州市",
        "value": "荆州市"
    },
    {
        "label": "黄冈市",
        "value": "黄冈市"
    },
    {
        "label": "咸宁市",
        "value": "咸宁市"
    },
    {
        "label": "随州市",
        "value": "随州市"
    },
    {
        "label": "恩施土家族苗族自治州",
        "value": "恩施土家族苗族自治州"
    },
    {
        "label": "仙桃市",
        "value": "仙桃市"
    },
    {
        "label": "潜江市",
        "value": "潜江市"
    },
    {
        "label": "天门市",
        "value": "天门市"
    },
    {
        "label": "神农架林区",
        "value": "神农架林区"
    }
    ]
},
{
    "label": "湖南省",
    "value": "湖南省",
    "children": [{
        "label": "长沙市",
        "value": "长沙市"
    },
    {
        "label": "株洲市",
        "value": "株洲市"
    },
    {
        "label": "湘潭市",
        "value": "湘潭市"
    },
    {
        "label": "衡阳市",
        "value": "衡阳市"
    },
    {
        "label": "邵阳市",
        "value": "邵阳市"
    },
    {
        "label": "岳阳市",
        "value": "岳阳市"
    },
    {
        "label": "常德市",
        "value": "常德市"
    },
    {
        "label": "张家界市",
        "value": "张家界市"
    },
    {
        "label": "益阳市",
        "value": "益阳市"
    },
    {
        "label": "郴州市",
        "value": "郴州市"
    },
    {
        "label": "永州市",
        "value": "永州市"
    },
    {
        "label": "怀化市",
        "value": "怀化市"
    },
    {
        "label": "娄底市",
        "value": "娄底市"
    },
    {
        "label": "湘西土家族苗族自治州",
        "value": "湘西土家族苗族自治州"
    }
    ]
},
{
    "label": "河北省",
    "value": "河北省",
    "children": [{
        "label": "石家庄市",
        "value": "石家庄市"
    },
    {
        "label": "唐山市",
        "value": "唐山市"
    },
    {
        "label": "秦皇岛市",
        "value": "秦皇岛市"
    },
    {
        "label": "邯郸市",
        "value": "邯郸市"
    },
    {
        "label": "邢台市",
        "value": "邢台市"
    },
    {
        "label": "保定市",
        "value": "保定市"
    },
    {
        "label": "张家口市",
        "value": "张家口市"
    },
    {
        "label": "承德市",
        "value": "承德市"
    },
    {
        "label": "沧州市",
        "value": "沧州市"
    },
    {
        "label": "廊坊市",
        "value": "廊坊市"
    },
    {
        "label": "衡水市",
        "value": "衡水市"
    }
    ]
},
{
    "label": "福建省",
    "value": "福建省",
    "children": [{
        "label": "福州市",
        "value": "福州市"
    },
    {
        "label": "厦门市",
        "value": "厦门市"
    },
    {
        "label": "莆田市",
        "value": "莆田市"
    },
    {
        "label": "三明市",
        "value": "三明市"
    },
    {
        "label": "泉州市",
        "value": "泉州市"
    },
    {
        "label": "漳州市",
        "value": "漳州市"
    },
    {
        "label": "南平市",
        "value": "南平市"
    },
    {
        "label": "龙岩市",
        "value": "龙岩市"
    },
    {
        "label": "宁德市",
        "value": "宁德市"
    }
    ]
},
{
    "label": "安徽省",
    "value": "安徽省",
    "children": [{
        "label": "合肥市",
        "value": "合肥市"
    },
    {
        "label": "芜湖市",
        "value": "芜湖市"
    },
    {
        "label": "蚌埠市",
        "value": "蚌埠市"
    },
    {
        "label": "淮南市",
        "value": "淮南市"
    },
    {
        "label": "马鞍山市",
        "value": "马鞍山市"
    },
    {
        "label": "淮北市",
        "value": "淮北市"
    },
    {
        "label": "铜陵市",
        "value": "铜陵市"
    },
    {
        "label": "安庆市",
        "value": "安庆市"
    },
    {
        "label": "黄山市",
        "value": "黄山市"
    },
    {
        "label": "滁州市",
        "value": "滁州市"
    },
    {
        "label": "阜阳市",
        "value": "阜阳市"
    },
    {
        "label": "宿州市",
        "value": "宿州市"
    },
    {
        "label": "六安市",
        "value": "六安市"
    },
    {
        "label": "亳州市",
        "value": "亳州市"
    },
    {
        "label": "池州市",
        "value": "池州市"
    },
    {
        "label": "宣城市",
        "value": "宣城市"
    }
    ]
},
{
    "label": "辽宁省",
    "value": "辽宁省",
    "children": [{
        "label": "沈阳市",
        "value": "沈阳市"
    },
    {
        "label": "大连市",
        "value": "大连市"
    },
    {
        "label": "鞍山市",
        "value": "鞍山市"
    },
    {
        "label": "抚顺市",
        "value": "抚顺市"
    },
    {
        "label": "本溪市",
        "value": "本溪市"
    },
    {
        "label": "丹东市",
        "value": "丹东市"
    },
    {
        "label": "锦州市",
        "value": "锦州市"
    },
    {
        "label": "营口市",
        "value": "营口市"
    },
    {
        "label": "阜新市",
        "value": "阜新市"
    },
    {
        "label": "辽阳市",
        "value": "辽阳市"
    },
    {
        "label": "盘锦市",
        "value": "盘锦市"
    },
    {
        "label": "铁岭市",
        "value": "铁岭市"
    },
    {
        "label": "朝阳市",
        "value": "朝阳市"
    },
    {
        "label": "葫芦岛市",
        "value": "葫芦岛市"
    }
    ]
},
{
    "label": "陕西省",
    "value": "陕西省",
    "children": [{
        "label": "西安市",
        "value": "西安市"
    },
    {
        "label": "铜川市",
        "value": "铜川市"
    },
    {
        "label": "宝鸡市",
        "value": "宝鸡市"
    },
    {
        "label": "咸阳市",
        "value": "咸阳市"
    },
    {
        "label": "渭南市",
        "value": "渭南市"
    },
    {
        "label": "延安市",
        "value": "延安市"
    },
    {
        "label": "汉中市",
        "value": "汉中市"
    },
    {
        "label": "榆林市",
        "value": "榆林市"
    },
    {
        "label": "安康市",
        "value": "安康市"
    },
    {
        "label": "商洛市",
        "value": "商洛市"
    }
    ]
},
{
    "label": "江西省",
    "value": "江西省",
    "children": [{
        "label": "南昌市",
        "value": "南昌市"
    },
    {
        "label": "景德镇市",
        "value": "景德镇市"
    },
    {
        "label": "萍乡市",
        "value": "萍乡市"
    },
    {
        "label": "九江市",
        "value": "九江市"
    },
    {
        "label": "新余市",
        "value": "新余市"
    },
    {
        "label": "鹰潭市",
        "value": "鹰潭市"
    },
    {
        "label": "赣州市",
        "value": "赣州市"
    },
    {
        "label": "吉安市",
        "value": "吉安市"
    },
    {
        "label": "宜春市",
        "value": "宜春市"
    },
    {
        "label": "抚州市",
        "value": "抚州市"
    },
    {
        "label": "上饶市",
        "value": "上饶市"
    }
    ]
},
{
    "label": "云南省",
    "value": "云南省",
    "children": [{
        "label": "昆明市",
        "value": "昆明市"
    },
    {
        "label": "曲靖市",
        "value": "曲靖市"
    },
    {
        "label": "玉溪市",
        "value": "玉溪市"
    },
    {
        "label": "保山市",
        "value": "保山市"
    },
    {
        "label": "昭通市",
        "value": "昭通市"
    },
    {
        "label": "丽江市",
        "value": "丽江市"
    },
    {
        "label": "普洱市",
        "value": "普洱市"
    },
    {
        "label": "临沧市",
        "value": "临沧市"
    },
    {
        "label": "楚雄彝族自治州",
        "value": "楚雄彝族自治州"
    },
    {
        "label": "红河哈尼族彝族自治州",
        "value": "红河哈尼族彝族自治州"
    },
    {
        "label": "文山壮族苗族自治州",
        "value": "文山壮族苗族自治州"
    },
    {
        "label": "西双版纳傣族自治州",
        "value": "西双版纳傣族自治州"
    },
    {
        "label": "大理白族自治州",
        "value": "大理白族自治州"
    },
    {
        "label": "德宏傣族景颇族自治州",
        "value": "德宏傣族景颇族自治州"
    },
    {
        "label": "怒江傈僳族自治州",
        "value": "怒江傈僳族自治州"
    },
    {
        "label": "迪庆藏族自治州",
        "value": "迪庆藏族自治州"
    }
    ]
},
{
    "label": "山西省",
    "value": "山西省",
    "children": [{
        "label": "太原市",
        "value": "太原市"
    },
    {
        "label": "大同市",
        "value": "大同市"
    },
    {
        "label": "阳泉市",
        "value": "阳泉市"
    },
    {
        "label": "长治市",
        "value": "长治市"
    },
    {
        "label": "晋城市",
        "value": "晋城市"
    },
    {
        "label": "朔州市",
        "value": "朔州市"
    },
    {
        "label": "晋中市",
        "value": "晋中市"
    },
    {
        "label": "运城市",
        "value": "运城市"
    },
    {
        "label": "忻州市",
        "value": "忻州市"
    },
    {
        "label": "临汾市",
        "value": "临汾市"
    },
    {
        "label": "吕梁市",
        "value": "吕梁市"
    }
    ]
},
{
    "label": "吉林省",
    "value": "吉林省",
    "children": [{
        "label": "长春市",
        "value": "长春市"
    },
    {
        "label": "吉林市",
        "value": "吉林市"
    },
    {
        "label": "四平市",
        "value": "四平市"
    },
    {
        "label": "辽源市",
        "value": "辽源市"
    },
    {
        "label": "通化市",
        "value": "通化市"
    },
    {
        "label": "白山市",
        "value": "白山市"
    },
    {
        "label": "松原市",
        "value": "松原市"
    },
    {
        "label": "白城市",
        "value": "白城市"
    },
    {
        "label": "延边朝鲜族自治州",
        "value": "延边朝鲜族自治州"
    }
    ]
},
{
    "label": "贵州省",
    "value": "贵州省",
    "children": [{
        "label": "贵阳市",
        "value": "贵阳市"
    },
    {
        "label": "六盘水市",
        "value": "六盘水市"
    },
    {
        "label": "遵义市",
        "value": "遵义市"
    },
    {
        "label": "安顺市",
        "value": "安顺市"
    },
    {
        "label": "毕节市",
        "value": "毕节市"
    },
    {
        "label": "铜仁市",
        "value": "铜仁市"
    },
    {
        "label": "黔西南布依族苗族自治州",
        "value": "黔西南布依族苗族自治州"
    },
    {
        "label": "黔东南苗族侗族自治州",
        "value": "黔东南苗族侗族自治州"
    },
    {
        "label": "黔南布依族苗族自治州",
        "value": "黔南布依族苗族自治州"
    }
    ]
},
{
    "label": "甘肃省",
    "value": "甘肃省",
    "children": [{
        "label": "兰州市",
        "value": "兰州市"
    },
    {
        "label": "嘉峪关市",
        "value": "嘉峪关市"
    },
    {
        "label": "金昌市",
        "value": "金昌市"
    },
    {
        "label": "白银市",
        "value": "白银市"
    },
    {
        "label": "天水市",
        "value": "天水市"
    },
    {
        "label": "武威市",
        "value": "武威市"
    },
    {
        "label": "张掖市",
        "value": "张掖市"
    },
    {
        "label": "平凉市",
        "value": "平凉市"
    },
    {
        "label": "酒泉市",
        "value": "酒泉市"
    },
    {
        "label": "庆阳市",
        "value": "庆阳市"
    },
    {
        "label": "定西市",
        "value": "定西市"
    },
    {
        "label": "陇南市",
        "value": "陇南市"
    },
    {
        "label": "临夏回族自治州",
        "value": "临夏回族自治州"
    },
    {
        "label": "甘南藏族自治州",
        "value": "甘南藏族自治州"
    }
    ]
},
{
    "label": "海南省",
    "value": "海南省",
    "children": [{
        "label": "海口市",
        "value": "海口市"
    },
    {
        "label": "三亚市",
        "value": "三亚市"
    },
    {
        "label": "三沙市",
        "value": "三沙市"
    },
    {
        "label": "儋州市",
        "value": "儋州市"
    },
    {
        "label": "五指山市",
        "value": "五指山市"
    },
    {
        "label": "琼海市",
        "value": "琼海市"
    },
    {
        "label": "文昌市",
        "value": "文昌市"
    },
    {
        "label": "万宁市",
        "value": "万宁市"
    },
    {
        "label": "东方市",
        "value": "东方市"
    },
    {
        "label": "定安县",
        "value": "定安县"
    },
    {
        "label": "屯昌县",
        "value": "屯昌县"
    },
    {
        "label": "澄迈县",
        "value": "澄迈县"
    },
    {
        "label": "临高县",
        "value": "临高县"
    },
    {
        "label": "白沙黎族自治县",
        "value": "白沙黎族自治县"
    },
    {
        "label": "昌江黎族自治县",
        "value": "昌江黎族自治县"
    },
    {
        "label": "乐东黎族自治县",
        "value": "乐东黎族自治县"
    },
    {
        "label": "陵水黎族自治县",
        "value": "陵水黎族自治县"
    },
    {
        "label": "保亭黎族苗族自治县",
        "value": "保亭黎族苗族自治县"
    },
    {
        "label": "琼中黎族苗族自治县",
        "value": "琼中黎族苗族自治县"
    }
    ]
},
{
    "label": "青海省",
    "value": "青海省",
    "children": [{
        "label": "西宁市",
        "value": "西宁市"
    },
    {
        "label": "海东市",
        "value": "海东市"
    },
    {
        "label": "海北藏族自治州",
        "value": "海北藏族自治州"
    },
    {
        "label": "黄南藏族自治州",
        "value": "黄南藏族自治州"
    },
    {
        "label": "海南藏族自治州",
        "value": "海南藏族自治州"
    },
    {
        "label": "果洛藏族自治州",
        "value": "果洛藏族自治州"
    },
    {
        "label": "玉树藏族自治州",
        "value": "玉树藏族自治州"
    },
    {
        "label": "海西蒙古族藏族自治州",
        "value": "海西蒙古族藏族自治州"
    }
    ]
},
{
    "label": "黑龙江省",
    "value": "黑龙江省",
    "children": [{
        "label": "哈尔滨市",
        "value": "哈尔滨市"
    },
    {
        "label": "齐齐哈尔市",
        "value": "齐齐哈尔市"
    },
    {
        "label": "鸡西市",
        "value": "鸡西市"
    },
    {
        "label": "鹤岗市",
        "value": "鹤岗市"
    },
    {
        "label": "双鸭山市",
        "value": "双鸭山市"
    },
    {
        "label": "大庆市",
        "value": "大庆市"
    },
    {
        "label": "伊春市",
        "value": "伊春市"
    },
    {
        "label": "佳木斯市",
        "value": "佳木斯市"
    },
    {
        "label": "七台河市",
        "value": "七台河市"
    },
    {
        "label": "牡丹江市",
        "value": "牡丹江市"
    },
    {
        "label": "黑河市",
        "value": "黑河市"
    },
    {
        "label": "绥化市",
        "value": "绥化市"
    },
    {
        "label": "大兴安岭地区",
        "value": "大兴安岭地区"
    }
    ]
},
{
    "label": "西藏自治区",
    "value": "西藏自治区",
    "children": [{
        "label": "拉萨市",
        "value": "拉萨市"
    },
    {
        "label": "日喀则市",
        "value": "日喀则市"
    },
    {
        "label": "昌都市",
        "value": "昌都市"
    },
    {
        "label": "林芝市",
        "value": "林芝市"
    },
    {
        "label": "山南市",
        "value": "山南市"
    },
    {
        "label": "那曲市",
        "value": "那曲市"
    },
    {
        "label": "阿里地区",
        "value": "阿里地区"
    }
    ]
},
{
    "label": "内蒙古自治区",
    "value": "内蒙古自治区",
    "children": [{
        "label": "呼和浩特市",
        "value": "呼和浩特市"
    },
    {
        "label": "包头市",
        "value": "包头市"
    },
    {
        "label": "乌海市",
        "value": "乌海市"
    },
    {
        "label": "赤峰市",
        "value": "赤峰市"
    },
    {
        "label": "通辽市",
        "value": "通辽市"
    },
    {
        "label": "鄂尔多斯市",
        "value": "鄂尔多斯市"
    },
    {
        "label": "呼伦贝尔市",
        "value": "呼伦贝尔市"
    },
    {
        "label": "巴彦淖尔市",
        "value": "巴彦淖尔市"
    },
    {
        "label": "乌兰察布市",
        "value": "乌兰察布市"
    },
    {
        "label": "兴安盟",
        "value": "兴安盟"
    },
    {
        "label": "锡林郭勒盟",
        "value": "锡林郭勒盟"
    },
    {
        "label": "阿拉善盟",
        "value": "阿拉善盟"
    }
    ]
},
{
    "label": "广西壮族自治区",
    "value": "广西壮族自治区",
    "children": [{
        "label": "南宁市",
        "value": "南宁市"
    },
    {
        "label": "柳州市",
        "value": "柳州市"
    },
    {
        "label": "桂林市",
        "value": "桂林市"
    },
    {
        "label": "梧州市",
        "value": "梧州市"
    },
    {
        "label": "北海市",
        "value": "北海市"
    },
    {
        "label": "防城港市",
        "value": "防城港市"
    },
    {
        "label": "钦州市",
        "value": "钦州市"
    },
    {
        "label": "贵港市",
        "value": "贵港市"
    },
    {
        "label": "玉林市",
        "value": "玉林市"
    },
    {
        "label": "百色市",
        "value": "百色市"
    },
    {
        "label": "贺州市",
        "value": "贺州市"
    },
    {
        "label": "河池市",
        "value": "河池市"
    },
    {
        "label": "来宾市",
        "value": "来宾市"
    },
    {
        "label": "崇左市",
        "value": "崇左市"
    }
    ]
},
{
    "label": "宁夏回族自治区",
    "value": "宁夏回族自治区",
    "children": [{
        "label": "银川市",
        "value": "银川市"
    },
    {
        "label": "石嘴山市",
        "value": "石嘴山市"
    },
    {
        "label": "吴忠市",
        "value": "吴忠市"
    },
    {
        "label": "固原市",
        "value": "固原市"
    },
    {
        "label": "中卫市",
        "value": "中卫市"
    }
    ]
},
{
    "label": "新疆维吾尔自治区",
    "value": "新疆维吾尔自治区",
    "children": [{
        "label": "乌鲁木齐市",
        "value": "乌鲁木齐市"
    },
    {
        "label": "克拉玛依市",
        "value": "克拉玛依市"
    },
    {
        "label": "吐鲁番市",
        "value": "吐鲁番市"
    },
    {
        "label": "哈密市",
        "value": "哈密市"
    },
    {
        "label": "昌吉回族自治州",
        "value": "昌吉回族自治州"
    },
    {
        "label": "博尔塔拉蒙古自治州",
        "value": "博尔塔拉蒙古自治州"
    },
    {
        "label": "巴音郭楞蒙古自治州",
        "value": "巴音郭楞蒙古自治州"
    },
    {
        "label": "阿克苏地区",
        "value": "阿克苏地区"
    },
    {
        "label": "克孜勒苏柯尔克孜自治州",
        "value": "克孜勒苏柯尔克孜自治州"
    },
    {
        "label": "喀什地区",
        "value": "喀什地区"
    },
    {
        "label": "和田地区",
        "value": "和田地区"
    },
    {
        "label": "伊犁哈萨克自治州",
        "value": "伊犁哈萨克自治州"
    },
    {
        "label": "塔城地区",
        "value": "塔城地区"
    },
    {
        "label": "阿勒泰地区",
        "value": "阿勒泰地区"
    },
    {
        "label": "石河子市",
        "value": "石河子市"
    },
    {
        "label": "阿拉尔市",
        "value": "阿拉尔市"
    },
    {
        "label": "图木舒克市",
        "value": "图木舒克市"
    },
    {
        "label": "五家渠市",
        "value": "五家渠市"
    },
    {
        "label": "北屯市",
        "value": "北屯市"
    },
    {
        "label": "铁门关市",
        "value": "铁门关市"
    },
    {
        "label": "双河市",
        "value": "双河市"
    },
    {
        "label": "可克达拉市",
        "value": "可克达拉市"
    },
    {
        "label": "昆玉市",
        "value": "昆玉市"
    },
    {
        "label": "胡杨河市",
        "value": "胡杨河市"
    }
    ]
},
{
    "label": "香港特别行政区",
    "value": "香港特别行政区",
    "children": [{
        "label": "香港特别行政区",
        "value": "香港特别行政区"
    }]
},
{
    "label": "澳门特别行政区",
    "value": "澳门特别行政区",
    "children": [{
        "label": "澳门特别行政区",
        "value": "澳门特别行政区"
    }]
},
{
    "label": "台湾省",
    "value": "台湾省",
    "children": [{
        "label": "台北市",
        "value": "台北市"
    },
    {
        "label": "新北市",
        "value": "新北市"
    },
    {
        "label": "桃园市",
        "value": "桃园市"
    },
    {
        "label": "台中市",
        "value": "台中市"
    },
    {
        "label": "台南市",
        "value": "台南市"
    },
    {
        "label": "高雄市",
        "value": "高雄市"
    }
    ]
}
]

function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

var signature = '';

function wxShare(that, desc) {
    var isWeiXin = that.comm.isWeiXin();
    if (isWeiXin) {
        var webUrl = location.href.split('#')[0];

        function shareDataSet() {
            var title = '签助签证';
            var imgUrl = 'https://resource.51emin.com/upload_image/2022-9-26/vc-upload-1664176239749-4/45.jpg';
            var link = location.href;
            desc = desc ? desc : '签助签证'

            wx.ready(function () {
                wx.updateAppMessageShareData({
                    title,
                    desc,
                    imgUrl,
                    link,
                    success: function () {
                        console.log('设置成功,111');
                    },
                    fail: function (e) {
                        console.log('设置失败,222', e);
                    },
                })
                wx.updateTimelineShareData({
                    title,
                    imgUrl,
                    link,
                    success: function () {
                        console.log('设置成功,333');
                    },
                    fail: function (e) {
                        console.log('设置失败,444', e);
                    },
                })
                wx.onMenuShareTimeline({
                    title,
                    imgUrl,
                    link,
                    success: function () {
                        console.log('设置成功,555');
                    },
                    complete: function (e) {
                        console.log('设置complete,666', e);
                    },
                })
                wx.onMenuShareAppMessage({
                    title,
                    desc,
                    imgUrl,
                    link,
                    success: function () {
                        console.log('设置成功,777');
                    },
                    complete: function (e) {
                        console.log('设置complete,888', e);
                    },
                });
            });
        }

        if (signature) {
            shareDataSet();
        }

        that.axios.get(that.comm.apiUrl + '/h5/shareData?url=' + webUrl).then(res => {
            var data = res.data;
            signature = data.signature;

            wx.config({
                debug: false,
                signature: data.signature,
                appId: data.appId,
                nonceStr: data.nonceStr,
                timestamp: data.timestamp,
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
            });

            shareDataSet();
        })
    }
}

// oss
const OSS = require('ali-oss');
var accessKeyId = 'LTAI5tQ2nMRbM64cF9qVej7c';
var accessKeySecret = 'gR2hvQsRMyA19RRjAIEQ05DaJ3juje';
var bucket = 'bailinog';
var region = 'oss-cn-beijing';
var bucket_url = 'https://resource.51emin.com/';

// 获取年月日
function getYmd() {
    var myDate = new Date();
    var y = myDate.getFullYear();
    var m = myDate.getMonth() + 1;
    var d = myDate.getDate();
    return 'upload_image/' + y + '-' + m + '-' + d;
}

function getCurrentPosition(fun) {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
        navigator.geolocation.getCurrentPosition(function (position) {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;
            var myGeo = new BMapGL.Geocoder();
            myGeo.getLocation(new BMapGL.Point(longitude, latitude), function (result) {
                fun && fun(result.addressComponents)
            });
        }, function () {
            fun && fun(false)
        })
    } else {
        fun && fun(false)
    }
}


/**
 * 获取时间差
 */
var chaTime = (date3) => {
    //计算出相差天数
    //   var days = Math.floor(date3 / (24 * 3600))

    //计算出小时数
    var leave1 = date3 //计算天数后剩余的秒数w
    var hours = Math.floor(leave1 / (3600));

    //计算相差分钟数
    var leave2 = leave1 % (3600) //计算小时数后剩余的秒数
    var minutes = Math.floor(leave2 / (60))

    //计算相差秒数
    var leave3 = leave2 % (60) //计算分钟数后剩余的秒数
    var seconds = Math.round(leave3);


    if (hours < 0 || minutes < 0 || seconds < 0) {
        return false;
    }

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return {
        hours,
        minutes,
        seconds
    };
}
/**
* * 数字转整数 如 100000 转为10万
* * @param {需要转化的数} num
* * @param {需要保留的小数位数} point
*
*/
var fromdateNum = (num, point) => {
    point = point ? point : 1;
    let numStr = parseInt(num).toString()
    // 十万以内直接返回
    if (numStr.length < 6) {
        return numStr;
    }
    //大于6位数是十万 (以10W分割 10W以下全部显示)
    else if (numStr.length > 5) {
        let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
        return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万';
    }
}

/**
 * 记录邀请信息
 */
function saveInviteInfo(axios, fullPath, inviteCode) {
    if (!inviteCode) {
        return
    }
    console.log(inviteCode)
    const url = `${webLink}/#${fullPath}`;
    console.log(url);

    let inviteList = foowwLocalStorage.get('inviteList') || []
    console.log('inviteList', inviteList)
    if (inviteList) {
        const inviteUrl = inviteList.find(item => item === url)
        if (inviteUrl) {
            return
        }
    }

    const inviteData = {
        url: url,
        inviteData: inviteCode,
        inviteIdCode: foowwLocalStorage.get('inviteIdCode')
    }
    axios.post(apiUrl + '/h5/invite/info', inviteData).then( res => {
        if (res.code === 200) {
            const inviteIdEndTime = new Date().getTime() + 3600000 * 24 * 365;
            foowwLocalStorage.set('inviteIdCode', res.data, inviteIdEndTime);
        } else {
            console.log('记录邀请信息失败: ', res.msg)
        }
        inviteList.push(url)
        const endTime = new Date().getTime() + 3600000 * 24 * 7 * 365;
        foowwLocalStorage.set('inviteList', inviteList, endTime);
    })

}

export default {
    yearList,
    fromdateNum,
    chaTime,
    getCurrentPosition,
    wxShare,
    getYmd,
    getRequest,
    urlencode,
    authorize,
    identityType,
    relationList,
    authorizeOrder,
    getAge,
    apiUrl,
    continent,
    emailReg,
    phoneReg,
    visaTypeList,
    foowwLocalStorage,
    showToast,
    provinceList,
    provinceJson,
    bodyNoSliding,
    bodySliding,
    formatTime,
    accessKeyId,
    accessKeySecret,
    bucket,
    region,
    bucket_url,
    environmentType,
    isWeiXin,
    setPvUv,
    saveInviteInfo
}



// WEBPACK FOOTER //
// ./src/util/com.js